import { render, staticRenderFns } from "./ReturnChargesFile.vue?vue&type=template&id=56624f30&scoped=true"
import script from "./ReturnChargesFile.vue?vue&type=script&lang=js"
export * from "./ReturnChargesFile.vue?vue&type=script&lang=js"
import style0 from "./ReturnChargesFile.vue?vue&type=style&index=0&id=56624f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56624f30",
  null
  
)

export default component.exports